<template>
  <div class="course-tip-dialog">
    <van-popup v-model="visiable" :close-on-click-overlay="false">
      <div class="course-tip-dialog-content">
        <img src="@/assets/images/home/course-tip-bg.png" alt="">
      </div>
      <div class="next-btn">
        <span class="next-btn-text" @click="closePopup">我知道啦</span>
      </div>
    </van-popup>
    <guide ref="guide" />
  </div>
</template>

<script>
import Guide from '@/components/Guide.vue'

export default {
  name: 'CourseTipDialog',
  components: {
    Guide
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visiable: false,
    }
  },
  watch: {
    value(val) {
      this.visiable = val
    }
  },
  methods: {
    startGuide() {
      const steps = [
        {
          step: '1',
          selector: '.course-entrance',
          icon: require('../../../assets/images/home/guide/step1.png'),
          iconWidth: 278
        },
      ]
      this.$refs.guide.start(steps)
    },
    closePopup() {
      localStorage.setItem('isReadCourseTip', 'true')
      this.$emit('input', false)
      this.startGuide()
    }
  }
}
</script>

<style scoped lang="less">
.course-tip-dialog {
  .course-tip-dialog-content {
    width: 320px;
    border-radius: 5px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 10px;

    img {
      width: 100%;
      max-height: 252px;
    }

  }

  .next-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;

    .next-btn-text {
      font-size: 14px;
      color: #fff;
      background: #EB1700;
      padding: 5px 20px;
      border-radius: 20px;
      cursor: pointer;
    }
  }

  /deep/ .van-popup {
    overflow-y: visible;
    z-index: 10008 !important;
    border-radius: 20px;
  }

  /deep/ .van-overlay {
    z-index: 10007 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/CourseTipDialog.vue